import { useEffect, useMemo, useRef, useState } from "react";
import { CustomerService } from "../../../../services/CustomerService";
import { ChangeAlertCallbackType } from "../../../Root";
import moment from "moment";
moment.locale("es");

export const useCustomerHistoryHandle = (changeAlert: ChangeAlertCallbackType) => {
    const [data, setData] = useState([]);
    const [uuid, setUuid] = useState("");
    const [loading, setLoading] = useState(false);
    const customerService = useRef<CustomerService>();

    const [tabActive, setTabActive] = useState("Login");
    const tabs = [
        { name: "Login", title: "Login" },
        { name: "Session", title: "Sesión" },
        { name: "Device", title: "Dispositivo" },
        { name: "Password", title: "Contraseña" },
    ];

    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);

    const saveData = async (result) => {
        setLoading(true);
        setData(result.content.list || []);
        setUuid(result.content.customer || "");
        setTotalRows(result["pagination"] ? result["pagination"]["total_records"] : 0);
        setTabActive("Login");
        setLoading(false);
    };

    const getData = async (
        newPage = page,
        newPerPage = rowsPerPage,
        tab = tabActive
    ) => {
        let service = `customerHistory${tab}`;

        let f = {
            customer: {
                uuid: uuid,
            },
        };
        if (tab !== "Device") {
            f["filter"] = {
                page_number: newPage,
                results_per_page: newPerPage,
            };
        }

        setLoading(true);
        const response = await customerService.current[service]({ data: f });
        if (response.data?.response === "OK") {
            if (response.data.widget.length > 0) {
                setData(response.data.widget[0].data?.content["list"] || []);
                setTotalRows(response.data.widget[0].data?.content["pagination"] ? response.data.widget[0].data?.content["pagination"]["total_records"] : 0);
            } else {
                setData(response.data?.content["list"] || []);
                setTotalRows(response.data["pagination"]["total_records"] || response.data?.content["list"].length || 0);
            }
            setLoading(false);
        } else {
            setLoading(false);
            changeAlert(true, "error", response.data.message);
        }
        setLoading(false);
    };

    const changePage = (action, page, rows = rowsPerPage) => {
        setPage(page + 1);
        getData(page + 1, rows, tabActive);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setRowsPerPage(JSON.parse(JSON.stringify(event.target.value)));
        changePage(null, 0, parseInt(event.target.value, 10));
    };

    const changeTab = (tab: string) => {
        setTabActive(tab["name"]);
        setData([]);
        setPage(1);
        getData(1, rowsPerPage, tab["name"]);
    };

    useEffect(() => {
        customerService.current = new CustomerService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const calculateColumns = useMemo(() => {
        let columns = [];

        switch (tabActive) {
            case "Login":
                columns = [
                    { selector: (row) => moment(row.cdate).format("YYYY-MM-DD HH:mm:ss"), name: 'Fecha', wrap: true, sortable: true },
                    { selector: (row) => row.source_ip, name: 'IP Address', wrap: true, sortable: true},
                    { selector: (row) => row.location, name: 'Geolocalización', wrap: true, sortable: true},
                    { selector: (row) => row.device_id, name: 'ID Device', wrap: true, sortable: true},
                    { selector: (row) => row.fingerprint, name: 'Fingerprint', wrap: true, sortable: true }
                ]
                break;
            case "Session":
                columns = [
                    { selector: (row) => moment(row.sdate).format("YYYY-MM-DD HH:mm:ss"), name: 'Fecha Inicio', wrap: true, sortable: true, width: "25%" },
                    { selector: (row) => row.edate ? moment(row.edate).format("YYYY-MM-DD HH:mm:ss") : 'No Aplica', name: 'Fecha Fin', wrap: true, sortable: true, width: "25%" },
                    { selector: (row) => row.original || 'No Aplica', name: 'Original', wrap: true, sortable: true},
                ]
                break;
            case "Device":
                columns = [
                    { selector: (row) => moment(row.cdate).format("YYYY-MM-DD HH:mm:ss"), name: 'Fecha', wrap: true, sortable: true },
                    { selector: (row) => row.device_name, name: 'Dispositivo', wrap: true, sortable: true},
                    { selector: (row) => row.app_version, name: 'APP Version', wrap: true, sortable: true},
                    { selector: (row) => row.device_id, name: 'ID Device', wrap: true, sortable: true},
                    { selector: (row) => row.fingerprint, name: 'Fingerprint', wrap: true, sortable: true },
                    { selector: (row) => row.mirai_sdk, name: 'Mirai SDK', wrap: true, sortable: true },
                    { selector: (row) => row.platform, name: 'Plataforma', wrap: true, sortable: true },
                    { selector: (row) => moment(row.udate).format("YYYY-MM-DD HH:mm:ss"), name: 'Actualización', wrap: true, sortable: true },
                ]
                break;
            case "Password":
                columns = [
                    { selector: (row) => moment(row.cdate).format("LL HH:mm:ss"), name: 'Fecha de Actualización de Contraseña', wrap: true, sortable: true },
                ]
                break;
            default:
                break;
        }

        return columns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabActive]);

    return {
        data,
        uuid,
        columns: calculateColumns,
        loading,
        page,
        rowsPerPage,
        totalRows,
        tabActive,
        tabs,
        saveData,
        changeTab,
        changePage,
        handleChangeRowsPerPage,
    };
};
